import fetch from '@/utils/fetch';

const api_url = process.env.VUE_APP_API;
// 获取商品详情
export const getAuthFunction = (uuid) => fetch({
  url: `${api_url}/cos/${uuid}`
});

